// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__WQZ8V","badges":"styles_badges__35vJF"};